const toCamelCase = (value: string): string =>
  value.replace(/[-_]+(.)/g, (_, character) => character.toUpperCase());

const isDynamicPathSegment = (segment: string): boolean =>
  /^\d+$/.test(segment) ||
  /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(segment) ||
  segment.length > 48;

const getPathSegments = (requestUrl: string): string[] => {
  const { pathname } = new URL(requestUrl, 'https://tracking.invalid');
  return pathname.split('/').filter(Boolean);
};

export const getCanonicalApiName = (requestUrl: string): string => {
  try {
    const segments = getPathSegments(requestUrl);

    for (let index = segments.length - 1; index >= 0; index -= 1) {
      const segment = segments[index];
      if (!isDynamicPathSegment(segment)) return toCamelCase(segment);
    }
  } catch {
    // A malformed or unavailable URL is reported without exposing raw data.
  }

  return 'unknownApi';
};

export const getApiSource = (requestUrl: string): string => {
  try {
    const segments = getPathSegments(requestUrl);
    const apiVersionIndex = segments.findIndex(
      (segment, index) =>
        segment === 'api' &&
        segments[index + 1] === 'sg' &&
        segments[index + 2] === 'v1'
    );
    const sourceSegment =
      apiVersionIndex >= 0 ? segments[apiVersionIndex + 3] : segments[0];

    if (sourceSegment === 'mcssapi' || sourceSegment?.startsWith('mcss')) {
      return 'mcss';
    }
    if (
      sourceSegment === 'online-eshop' ||
      sourceSegment?.startsWith('eshop')
    ) {
      return 'eshop';
    }
  } catch {
    // An unknown URL is grouped without exposing the raw URL.
  }

  return 'unknown';
};
